// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"HidePointModal_modalForm__3f_Xf","chipsSelector":"HidePointModal_chipsSelector__1L64W"};